import React from 'react';
import '../../styles/kyro-design.css';
import './Aman.css';

const Aman: React.FC = () => {
  return (
    <div className="page">
      <div className="aman-card-wrap">
        <div className="aman-card">
          <img
            src="/assets/team/aman-maheshwari.jpeg"
            alt="Aman Maheshwari"
            className="aman-photo"
          />
          <div className="aman-details">
            <div className="eyebrow">Contact Details</div>
            <div className="sec-title" style={{ fontSize: 'clamp(1.3rem, 2vw, 1.7rem)' }}>
              Aman Maheshwari
            </div>
            <p className="sec-body" style={{ marginBottom: '1rem' }}>
              Founder & Fund Manager, Kyro Asset Management and Kyro Capital.
            </p>
            <div className="aman-meta">
              <a href="mailto:aman@kyrocapital.in">aman@kyrocapital.in</a>
              <a href="tel:+918989733301">+91 89897 33301</a>
              <a href="https://kyrocapital.in/aman" target="_blank" rel="noopener noreferrer">kyrocapital.in/aman</a>
            </div>
            <div className="hero-btns">
              <a className="btn-p" href="/aman.vcf" download>
                Save Aman to Contacts
              </a>
              <a className="btn-g" href="mailto:aman@kyrocapital.in">
                Email Aman
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aman;
